import './Leasing.scss';

import { Segmented } from 'antd';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router';

import IndividualLeasings from './IndividualLeasings';
import LegalEntityLeasings from './LegalEntityLeasings';

const TABS = [
  { label: 'Физ. лица', key: 'individual' },
  { label: 'Юр. лица', key: 'legal-entity' }
] as const satisfies { label: string; key: string }[];

type Tabs = (typeof TABS)[number]['key'];

const TAB_KEY = 'tab';

const pages: Record<Tabs, React.ReactNode> = {
  individual: <IndividualLeasings />,
  'legal-entity': <LegalEntityLeasings />
};

const Leasing = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = searchParams.get(TAB_KEY);

  const [activeTab, setActiveTab] = useState<Tabs>(
    TABS.find((item) => item.key === tab)?.key || TABS[0].key
  );

  const onSetTab = (value: string) => {
    const selectedTabValue = TABS.find((item) => item.label === value)?.key;

    if (selectedTabValue) {
      setActiveTab(selectedTabValue);
      const params = new URLSearchParams();
      params.set(TAB_KEY, selectedTabValue);
      setSearchParams(params);
    }
  };

  useEffect(() => {
    if (tab !== activeTab) {
      setActiveTab(TABS.find((item) => item.key === tab)?.key || TABS[0].key);
    }
  }, [tab]);

  return (
    <div className="leasing">
      <Segmented
        block
        className="leasing__segmented"
        options={TABS.map((item) => item.label)}
        value={TABS.find((item) => item.key === activeTab)?.label}
        onChange={onSetTab}
      />
      <div className="leasing__content">{pages[activeTab]}</div>
    </div>
  );
};

export default Leasing;
